const API_URL = process.env.NODE_ENV === 'production' 
  ? 'https://planning.salin247.com/api' 
  : 'http://localhost:5001';

export default API_URL;